import React from "react";
import SEO from "../../../components/SEO";

export default function TermsConditions() {
  
  return (
    <>
    <SEO
      title="Conditions générales d'utilisation | einsured.ca Canada"
      description="Consultez les conditions générales d’utilisation d’einsured.ca, incluant les services, droits, données personnelles et obligations des utilisateurs."
    />
    <div className="bg-white text-[#111827]">
      <section className="max-w-6xl mx-auto px-4 sm:px-6 md:px-20 pt-14 sm:pt-16 pb-16 sm:pb-20">
        {/* MAIN HEADING */}
        <h1 className="text-2xl sm:text-4xl md:text-5xl font-bold text-center mb-8 sm:mb-12 text-[#49628b]">
          Conditions générales d'utilisation
        </h1>

        <div className="space-y-6 sm:space-y-7 text-sm sm:text-base leading-relaxed">
          {/* INTRODUCTION */}
          <h2 className="text-lg sm:text-xl font-bold text-[#111827]">
            Bienvenue sur einsured.ca !
          </h2>
          <p>
            Vous trouverez ci-dessous les conditions générales d'utilisation du
            site Web ci-dessous :{" "}
            <a
              href="https://einsured.fresho.ca/"
              className="text-sky-600 underline"
            >
              https://einsured.fresho.ca/
            </a>
            . En utilisant le site Web et les services, vous acceptez d'être lié
            par ces conditions générales et notre politique de confidentialité.
            Dans ces conditions générales, les termes « site Web » désignent le
            site Web d'einsured.ca, « nous », « notre » et « einsured.ca »
            désignent einsured.ca Inc. et « vous » et « utilisateur » vous
            désignent, l'utilisateur d'einsured.ca. Les conditions générales
            suivantes s'appliquent au site Web et aux services offerts par
            einsured.ca. Cela comprend les versions mobiles et tablettes ainsi
            que toute autre version d'einsured.ca accessible via ordinateur de
            bureau, mobile, tablette, réseaux sociaux ou autres appareils.
          </p>

          <h2 className="text-lg sm:text-xl font-bold text-[#111827]">
            LISEZ ATTENTIVEMENT CES CONDITIONS GÉNÉRALES AVANT D'UTILISER OU
            D'OBTENIR DES INFORMATIONS OU DES SERVICES D'EINSURED.CA.
          </h2>

          {/* 1. ACCEPTANCE OF TERMS */}
          <h2 className="text-lg sm:text-xl font-bold text-[#111827]">
            1. ACCEPTATION DES CONDITIONS
          </h2>
          <p>
            Cet accord établit des conditions juridiquement contraignantes pour
            votre utilisation d'einsured.ca. En utilisant le site Web et les
            services, vous acceptez d'être lié par cet accord. Si vous
            n'acceptez pas les conditions de cet accord, vous ne devez pas
            utiliser le site Web et les services. Nous pouvons modifier cet
            accord de temps à autre, et cette modification sera effective lors
            de sa publication sur le site Web. Vous acceptez d'être lié par
            toute modification de ces conditions générales lorsque vous utilisez
            le site Web et les services offerts sur le site Web après la
            publication de cette modification ; il est donc important que vous
            examiniez régulièrement cet accord.
          </p>

          <p>
            L'accès au site Web et l'utilisation des services sont disponibles
            pour tous les âges. Il incombe aux parents et aux tuteurs légaux de
            déterminer si le contenu et les services offerts sur le site Web sont
            appropriés pour leurs enfants ou mineurs sous leur tutelle.
            einsured.ca peut, à sa seule discrétion, refuser d'offrir les
            services à toute entité et modifier ses critères d'admissibilité à
            tout moment. Cette disposition est nulle lorsqu'elle est interdite
            par la loi et le droit d'accès au service et au site Web est révoqué
            dans ces juridictions.
          </p>

          <p>
            Le site Web et les services ne peuvent être utilisés que conformément
            à ces conditions et à toutes les lois, règles et réglementations
            locales, provinciales, nationales et internationales applicables.
          </p>

          <p>
            En fournissant à einsured.ca votre adresse e-mail, vous consentez à
            notre utilisation de votre adresse e-mail pour vous envoyer des avis
            sur les services, y compris ceux requis par la loi. Nous pouvons
            également utiliser votre adresse e-mail pour vous envoyer des
            notifications et d'autres messages, tels que des modifications des
            fonctionnalités du service, des nouvelles et du contenu spécial. Si
            vous ne souhaitez pas recevoir ces e-mails, vous pouvez vous
            désabonner en nous envoyant votre demande de retrait via les
            coordonnées ou en utilisant l'option « se désabonner » dans les
            e-mails. Le désabonnement peut vous empêcher de recevoir des e-mails
            concernant les mises à jour, les nouvelles ou le contenu spécial.
          </p>

          <p>
            En utilisant le site Web et les services, vous déclarez et garantissez
            que vous avez le droit, le pouvoir et l'autorité de conclure cet
            accord et d'exécuter pleinement toutes vos obligations en vertu de
            celui-ci. Vous déclarez et garantissez en outre que vous n'êtes
            soumis à aucune incapacité légale ou restriction contractuelle qui
            vous empêcherait de conclure cet accord.
          </p>

          {/* 2. SERVICES */}
          <h2 className="mt-8 text-lg sm:text-xl font-bold text-[#111827]">
            2. SERVICES
          </h2>
          <p>einsured.ca offre les services suivants :</p>
          <ul className="list-disc list-inside pl-4 sm:pl-6 space-y-1">
            <li>Assurance-vie</li>
            <li>Assurance maladies graves</li>
            <li>Assurance invalidité</li>
            <li>Assurance pour Super Visa</li>
            <li>Compte d'épargne libre d'impôt</li>
            <li>Régimes enregistrés d'épargne-retraite</li>
            <li>Régimes enregistrés d'épargne-études</li>
          </ul>
          <div className="space-y-4">
  <p>
    Les utilisateurs peuvent demander des devis via le site Web ou planifier
    une réunion via le site Web ou en appelant notre numéro de téléphone. Pour
    demander un devis, veuillez remplir le formulaire disponible sur le site
    Web. Veuillez noter que le prix indiqué dans les devis peut varier du prix
    réel, sauf indication contraire.
  </p>

  <p>
    Pour planifier une réunion, veuillez sélectionner la date et l'heure de la
    réunion et confirmer la réservation via le site Web. Si vous souhaitez
    modifier ou annuler une réunion planifiée, veuillez nous contacter via nos
    coordonnées.
  </p>

  <p>
    Les données fournies lors des réunions et des demandes de devis seront
    traitées et stockées conformément à notre politique de confidentialité.
  </p>

  <p>
    Le prix des services sera déterminé en fonction des services contractés par
    l'utilisateur, conformément aux contrats qu'einsured.ca Inc. a avec les
    compagnies d'assurance qu'einsured.ca Inc. représente. Vous n'êtes pas
    obligé de payer de frais ou de paiements à einsured.ca Inc. pour les
    services que vous obtenez. einsured.ca Inc. est rémunéré conformément au
    document de divulgation que vous signerez lors de votre première réunion ou
    des réunions suivantes avec l'un de nos conseillers.
  </p>

  <p>
    Pour plus d'informations sur nos services, vous pouvez prendre rendez-vous
    via notre site Web ou nous contacter via notre numéro de téléphone (844)
    440-0128.
  </p>
</div>

          {/* 3. DISCLAIMER */}
          <h2 className="mt-8 text-lg sm:text-xl font-bold text-[#111827]">
            3. AVIS DE NON-RESPONSABILITÉ
          </h2>
          <p>
            En accédant au site Web et au contenu disponible sur celui-ci, vous
            acceptez la responsabilité personnelle des résultats de l'utilisation
            des informations disponibles sur le contenu. Vous acceptez
            qu'einsured.ca n'a pas garanti les résultats des actions entreprises,
            qu'elles aient été ou non conseillées par ce site Web ou le contenu.
            einsured.ca fournit des ressources et du contenu à des fins
            d'information uniquement. Nous ne garantissons pas que les
            informations disponibles sur le site Web sont exactes, complètes ou
            mises à jour. Le contenu de ce site Web est fourni à titre
            d'information générale et ne doit pas être considéré comme un conseil
            professionnel. Toute utilisation du matériel fourni sur ce site Web
            se fait à vos propres risques.
          </p>

          {/* 4. THIRD-PARTY MATERIALS */}
          <h2 className="mt-8 text-lg sm:text-xl font-bold text-[#111827]">
            4. MATÉRIAUX DE TIERS
          </h2>
          <p>
            Les « Matériaux de tiers » désignent tout contenu, images, vidéos,
            textes ou autres matériaux appartenant à un tiers, tels que des
            images, vidéos et textes de stock. Ces matériaux de tiers sont
            soumis aux conditions et licences applicables des tiers, et ne
            peuvent être utilisés que dans la mesure permise par ces conditions
            et licences.
          </p>

          {/* 5. COPYRIGHT */}
          <h2 className="mt-8 text-lg sm:text-xl font-bold text-[#111827]">
            5. DROIT D'AUTEUR
          </h2>
          <p>
            Tous les matériaux sur einsured.ca, y compris, sans limitation, les
            noms, logos, marques de commerce, images, textes, colonnes,
            graphiques, vidéos, photographies, illustrations, logiciels et autres
            éléments sont protégés par des droits d'auteur, des marques de
            commerce et/ou d'autres droits de propriété intellectuelle détenus et
            contrôlés par einsured.ca ou par des tiers qui ont concédé sous
            licence ou autrement fourni leur matériel au site Web. Vous
            reconnaissez et acceptez que tous les matériaux sur einsured.ca sont
            mis à disposition pour un usage personnel limité, non commercial
            uniquement. Sauf disposition spécifique dans les présentes. Aucun
            matériel ne peut être copié, reproduit, republié, vendu, téléchargé,
            publié, transmis ou distribué de quelque manière que ce soit, ou
            autrement utilisé à quelque fin que ce soit, par toute personne ou
            entité, sans l'autorisation écrite préalable expresse d'einsured.ca.
            Vous ne pouvez pas ajouter, supprimer, déformer ou modifier autrement
            le matériel. Toute tentative non autorisée de modifier tout matériel,
            de contourner ou déjouer toute mesure de sécurité, ou d'utiliser
            einsured.ca ou toute partie du matériel à des fins autres que ses
            fins prévues est strictement interdite.
          </p>

          {/* 6. COPYRIGHT INFRINGEMENT */}
          <h2 className="mt-8 text-lg sm:text-xl font-bold text-[#111827]">
            6. VIOLATION DES DROITS D'AUTEUR
          </h2>

          <p className="text-gray-700">
            einsured.ca répondra à toutes les demandes, plaintes et réclamations
            concernant la prétendue violation par infraction ou violation des
            dispositions contenues dans les réglementations canadiennes et
            internationales sur le droit d'auteur. einsured.ca respecte la
            propriété intellectuelle d'autrui et attend des utilisateurs qu'ils
            fassent de même. Si vous croyez, de bonne foi, que tout matériel
            fourni sur ou en relation avec la plateforme einsured.ca enfreint
            votre droit d'auteur ou autre droit de propriété intellectuelle,
            veuillez nous soumettre votre demande via nos coordonnées, avec les
            informations suivantes :
          </p>

          <ul className="list-disc pl-6 space-y-2 text-gray-700">
            <li>
              Identification du droit de propriété intellectuelle prétendument
              violé. Tous les numéros d'enregistrement pertinents ou une
              déclaration concernant la propriété de l'œuvre doivent être inclus.
            </li>
            <li>
              Une déclaration identifiant spécifiquement l'emplacement du
              matériel contrefaisant, avec suffisamment de détails pour
              qu'einsured.ca puisse le trouver sur le site Web.
            </li>
            <li>Votre nom, adresse, numéro de téléphone et adresse e-mail.</li>
            <li>
              Une déclaration de votre part indiquant que vous croyez de bonne
              foi que l'utilisation du matériel prétendument contrefaisant n'est
              pas autorisée par le titulaire des droits d'auteur, ses agents ou
              par la loi.
            </li>
            <li>
              Une déclaration de votre part, faite sous peine de parjure, selon
              laquelle les informations contenues dans votre notification sont
              exactes et que vous êtes le titulaire des droits d'auteur ou
              autorisé à agir en son nom.
            </li>
            <li>
              Une signature électronique ou physique du titulaire des droits
              d'auteur ou de la personne autorisée à agir au nom du titulaire
              des droits d'auteur.
            </li>
          </ul>

          {/* 7. PERSONAL DATA */}
          <h2 className="mt-8 text-lg sm:text-xl font-bold text-[#111827]">
            7. DONNÉES PERSONNELLES
          </h2>
          <p>
            Toute information personnelle que vous publiez ou soumettez en
            relation avec les services et l'utilisation du site Web sera
            utilisée conformément à notre politique de confidentialité. En
            utilisant les services, vous acceptez que nous puissions collecter
            et stocker vos informations personnelles. Veuillez consulter notre
            politique de confidentialité.
          </p>

          {/* 8. PROHIBITED ACTIVITIES */}
          <h2 className="mt-8 text-lg sm:text-xl font-bold text-[#111827]">
            8. ACTIVITÉS INTERDITES
          </h2>

          <p className="text-gray-700">
            Le contenu et les informations disponibles sur le site Web (y
            compris, mais sans s'y limiter, les données, informations, textes,
            musiques, sons, photos, graphiques, vidéos, cartes, icônes ou autres
            matériaux), ainsi que l'infrastructure utilisée pour fournir ce
            contenu et ces informations, sont la propriété d'einsured.ca ou
            concédés sous licence à einsured.ca par des tiers. Pour tout contenu
            autre que votre contenu, vous acceptez de ne pas modifier, copier,
            distribuer, transmettre, afficher, exécuter, reproduire, publier,
            concéder sous licence, créer des œuvres dérivées, transférer ou
            vendre ou revendre des informations, logiciels ou services obtenus
            via ou via le site Web. En outre, les activités suivantes sont
            interdites :
          </p>

          <ul className="list-disc pl-6 space-y-2 text-gray-700">
            <li>
              Accéder, surveiller, reproduire, distribuer, transmettre,
              diffuser, afficher, vendre, concéder sous licence, copier ou
              exploiter autrement tout contenu des services, y compris, mais sans
              s'y limiter, en utilisant tout robot, araignée, scraper ou tout
              autre moyen automatisé ou tout processus manuel à toute fin non
              conforme à cet accord ou sans notre autorisation écrite expresse.
            </li>
            <li>
              Violer les restrictions dans tous les en-têtes d'exclusion de
              robots sur les services ou contourner d'autres mesures employées
              pour empêcher ou limiter l'accès aux services.
            </li>
            <li>
              Prendre toute action qui impose, ou pourrait imposer, à notre
              discrétion, une charge déraisonnable ou disproportionnément grande
              sur notre infrastructure.
            </li>
            <li>
              Établir des liens profonds vers toute partie des services à
              quelque fin que ce soit sans notre autorisation écrite expresse.
            </li>
            <li>
              « Encadrer », « miroir » ou autrement incorporer toute partie des
              services dans d'autres sites Web ou services sans notre autorisation
              écrite préalable.
            </li>
            <li>
              Tenter de modifier, traduire, adapter, éditer, décompiler,
              désassembler ou décompiler tout programme logiciel utilisé par
              einsured.ca en relation avec les services.
            </li>
            <li>
              Contourner, désactiver ou autrement interférer avec les
              fonctionnalités liées à la sécurité des services ou les
              fonctionnalités qui empêchent ou restreignent l'utilisation ou la
              copie de tout contenu.
            </li>
            <li>
              Télécharger tout contenu sauf s'il est expressément mis à
              disposition pour téléchargement par einsured.ca.
            </li>
          </ul>

          {/* ===== 9. DISCLAIMER OF WARRANTIES ===== */}
          <h2 className="mt-8 text-lg sm:text-xl font-bold text-[#111827]">
            9. EXCLUSION DE GARANTIES
          </h2>

          <ul className="list-disc pl-6 space-y-2 text-gray-700">
            <li>
              En raison de la nature d'Internet, einsured.ca fournit et maintient
              le site Web sur une base « telle quelle », « telle que disponible »
              et ne fait aucune promesse que l'utilisation du site Web sera
              ininterrompue ou entièrement sans erreur. Nous ne sommes pas
              responsables envers vous si nous sommes incapables de fournir nos
              services Internet pour des raisons indépendantes de notre volonté.
            </li>

            <li>
              Notre site Web peut de temps à autre contenir des liens vers
              d'autres sites Web qui ne sont pas sous notre contrôle et ne sont
              pas maintenus par nous. Ces liens sont fournis uniquement pour votre
              commodité et nous ne sommes pas responsables du contenu de ces
              sites.
            </li>

            <li>
              Sauf disposition contraire ci-dessus, nous ne pouvons donner
              aucune autre garantie, condition ou autre terme, expresse ou
              implicite, légale ou autre, et tous ces termes sont par les
              présentes exclus dans la mesure maximale permise par la loi.
            </li>

            <li>
              Vous serez responsable de toute violation de ces conditions de votre
              part et si vous utilisez le site Web en violation de ces conditions,
              vous serez responsable envers einsured.ca et lui rembourserez toute
              perte ou dommage causé en conséquence.
            </li>

            <li>
              einsured.ca ne sera pas responsable pour tout montant dû à
              l'inexécution de toute obligation en vertu de cet accord si cette
              inexécution est causée par la survenance d'un événement imprévu
              indépendant de sa volonté raisonnable, notamment sans limitation
              les pannes d'Internet, les pannes de communication, les incendies,
              les inondations, les guerres ou les actes de Dieu.
            </li>

            <li>
              Ces conditions n'affectent pas vos droits légaux en tant que
              consommateur qui vous sont disponibles.
            </li>

            <li>
              Sous réserve de ce qui précède, dans la mesure maximale permise par
              la loi, einsured.ca exclut toute responsabilité pour toute perte ou
              dommage de quelque nature que ce soit, y compris, sans limitation,
              toute perte directe, indirecte ou consécutive, qu'elle résulte ou
              non d'un problème que vous signalez à einsured.ca, et einsured.ca
              n'aura aucune responsabilité de payer de l'argent à titre
              d'indemnisation, y compris, sans limitation, toute responsabilité
              en relation avec :
              <ul className="mt-2 list-disc pl-6 space-y-2">
                <li>Toute information incorrecte ou inexacte sur le site Web.</li>
                <li>
                  La violation par toute personne de tout droit de propriété
                  intellectuelle de tout tiers causée par son utilisation du
                  site Web ou du service acheté via le site Web.
                </li>
                <li>
                  Toute perte ou dommage résultant de votre utilisation ou de
                  l'impossibilité d'utiliser le site Web ou résultant d'un accès
                  non autorisé à vos transmissions ou données, ou de leur
                  modification, dans des circonstances indépendantes de notre
                  volonté.
                </li>
                <li>
                  Toute perte de profit, dépense inutile, corruption ou
                  destruction de données ou toute autre perte qui ne résulte pas
                  directement de quelque chose que nous avons mal fait.
                </li>
                <li>
                  Tout montant ou type de perte ou de dommage dû à des virus ou
                  autres logiciels malveillants susceptibles d'infecter
                  l'équipement informatique, les logiciels, les données ou
                  autres propriétés d'un utilisateur causés par des personnes
                  accédant au contenu du site Web ou l'utilisant ou par des
                  transmissions via des e-mails ou des pièces jointes reçus
                  d'einsured.ca.
                </li>
                <li>
                  Toutes les déclarations, garanties, conditions et autres termes
                  qui, sans cet avis, auraient effet.
                </li>
              </ul>
            </li>
          </ul>

          {/* ===== 10. ELECTRONIC COMMUNICATIONS ===== */}
          <h2 className="mt-8 text-lg sm:text-xl font-bold text-[#111827]">
            10. COMMUNICATIONS ÉLECTRONIQUES
          </h2>
          <p>
            Aucune responsabilité ne sera acceptée par einsured.ca pour les
            transmissions informatiques échouées, partielles ou tronquées, pour
            tout dysfonctionnement, panne, connexion, accessibilité ou
            disponibilité d'Internet d'ordinateur, téléphone, câble, réseau,
            électronique ou matériel ou logiciel Internet, ou pour la congestion
            du trafic ou les actes humains non autorisés, y compris les erreurs
            ou les fautes.
          </p>

          {/* ===== 11. INDEMNIFICATION ===== */}
          <h2 className="mt-8 text-lg sm:text-xl font-bold text-[#111827]">
            11. INDEMNISATION
          </h2>

          <p className="text-gray-700">
            Vous acceptez de défendre et d'indemniser einsured.ca contre toute
            réclamation, cause d'action, demande, recouvrement, perte, dommage,
            amende, pénalité ou autre coût ou dépense de quelque nature ou nature
            que ce soit, y compris, mais sans s'y limiter, les frais juridiques
            et comptables raisonnables, portés par des tiers en conséquence de :
          </p>

          <ul className="list-disc pl-6 space-y-2 text-gray-700">
            <li>Votre violation de cet accord ou des documents référencés dans les présentes.</li>
            <li>Votre violation de toute loi ou des droits d'un tiers.</li>
            <li>Votre utilisation du site Web et des services.</li>
          </ul>

          {/* ===== 12. CHANGES AND TERMINATION ===== */}
          <h2 className="mt-8 text-lg sm:text-xl font-bold text-[#111827]">
            12. MODIFICATIONS ET RÉSILIATION
          </h2>
          <p>
            Nous pouvons modifier le site Web et ces conditions à tout moment, à
            notre seule discrétion et sans vous en aviser. Vous êtes responsable
            de rester informé de ces conditions. Votre utilisation continue du
            site constitue votre acceptation de toute modification de ces
            conditions, et toute modification remplacera toutes les versions
            précédentes des conditions. Sauf indication contraire dans les
            présentes, toutes les modifications de ces conditions s'appliquent à
            tous les utilisateurs et prennent effet. De plus, nous pouvons
            résilier cet accord avec vous en vertu de ces conditions à tout
            moment en vous en informant par écrit (y compris par e-mail) ou sans
            préavis.
          </p>

          {/* ===== 13. ASSIGNMENT ===== */}
          <h2 className="mt-8 text-lg sm:text-xl font-bold text-[#111827]">
            13. CESSION
          </h2>
          <p>
            Cet accord et tout droit et licence accordés dans les présentes ne
            peuvent pas être transférés ou cédés par vous, mais peuvent être
            cédés par einsured.ca sans restriction.
          </p>

          {/* ===== 14. INTEGRATION CLAUSE ===== */}
          <h2 className="mt-8 text-lg sm:text-xl font-bold text-[#111827]">
            14. CLAUSE D'INTÉGRATION
          </h2>
          <p>
            Cet accord ainsi que la politique de confidentialité et tout autre
            avis légal publié par einsured.ca constituent l'accord complet entre
            vous et einsured.ca concernant et régissant votre utilisation du
            site Web et des services.
          </p>

          {/* ===== 15. DISPUTES ===== */}
          <h2 className="mt-8 text-lg sm:text-xl font-bold text-[#111827]">
            15. LITIGES
          </h2>

          <ul className="list-disc pl-6 space-y-2 text-gray-700">
            <li>
              L'utilisateur accepte que tout litige, réclamation ou controverse
              découlant ou lié à ces conditions générales, ou à leur violation,
              résiliation, exécution, interprétation ou validité, ou à
              l'utilisation des services, soit résolu par arbitrage contraignant
              entre l'utilisateur et einsured.ca, à condition que chaque partie
              conserve le droit d'engager une action individuelle devant le
              tribunal de l'Ontario.
            </li>

            <li>
              En cas de litige lié à l'utilisation des services ou à la violation
              de ces conditions, les parties acceptent de soumettre leur litige à
              une résolution par arbitrage devant une organisation d'arbitrage
              réputée, mutuellement convenue par les parties et conformément aux
              règles d'arbitrage commercial applicables.
            </li>

            <li>
              Vous acceptez d'initier une procédure formelle de règlement des
              litiges en nous envoyant une communication via nos coordonnées.
              einsured.ca peut choisir de vous envoyer une offre écrite après
              réception de votre communication initiale. Si nous vous offrons et
              envoyons une offre de règlement et que vous n'acceptez pas l'offre,
              ou si nous ne pouvons pas résoudre votre litige de manière
              satisfaisante et que vous souhaitez poursuivre le processus de
              règlement des litiges, vous devez initier le processus de règlement
              des litiges devant une organisation d'arbitrage accréditée et
              déposer une demande d'arbitrage séparée. Toute sentence rendue par
              le tribunal d'arbitrage sera définitive et contraignante pour les
              parties.
            </li>

            <li>
              Dans toute la mesure permise par la loi, vous acceptez de ne pas
              déposer, rejoindre ou participer à tout recours collectif en
              relation avec toute réclamation, litige ou controverse pouvant
              survenir en relation avec votre utilisation du site Web et des
              services.
            </li>

            <li>
              Le tribunal de l'Ontario aura juridiction sur tout litige,
              controverse ou réclamation relatif à einsured.ca et à ses
              opérations commerciales. Tout litige ou controverse de ce type sera
              porté et résolu devant le tribunal de l'Ontario.
            </li>
          </ul>

          {/* ===== 16. FINAL PROVISIONS ===== */}
          <h2 className="mt-8 text-lg sm:text-xl font-bold text-[#111827]">
            16. DISPOSITIONS FINALES
          </h2>
          <div className="space-y-4">
  <p>
    Ces conditions générales sont régies par les lois du Canada. L'utilisation
    du site Web et des services n'est pas autorisée dans toute juridiction qui
    ne donne pas effet à toutes les dispositions de ces conditions.
  </p>

  <p>
    Notre exécution de ces conditions est soumise aux lois et processus
    juridiques existants, et rien dans ces conditions ne limite notre droit de
    nous conformer aux demandes ou exigences des forces de l'ordre ou d'autres
    demandes ou exigences gouvernementales ou juridiques relatives à votre
    utilisation de notre site Web ou aux informations fournies à ou collectées
    par nous à cet égard.
  </p>

  <p>
    Si une partie de ces conditions s'avère invalide, illégale ou inapplicable,
    la validité, la légalité et l'applicabilité des dispositions restantes ne
    seront en aucune façon affectées ou compromises. Notre incapacité ou délai à
    faire respecter toute disposition de ces conditions à tout moment ne renonce
    pas à notre droit de faire respecter la même ou toute autre disposition à
    l'avenir. Tous droits non expressément accordés dans les présentes sont
    réservés.
  </p>
</div>

          {/* ===== 17. CONTACT INFORMATION ===== */}
          <h2 className="mt-8 text-lg sm:text-xl font-bold text-[#111827]">
            17. COORDONNÉES
          </h2>
          <p>
            Si vous avez des questions ou des préoccupations concernant ces
            conditions, veuillez nous contacter via notre page de contact ou via
            les coordonnées ci-dessous :
            <br />
            einsured.ca Inc.
            <br />
            <strong> Aman Ahuja, eadmin@einsured.ca, (844) 440-0128 </strong>
          </p>
        </div>
      </section>
    </div>
    </>

  );
}
